import React from "react";

export const AdminLogin = () => {
	return (
		<div style={{ height: '100vh', width: '100%' }}>
			<iframe
				src={`${process.env.REACT_APP_BACKEND_URL}/#/adminLogin`}
				style={{ border: 'none', width: '100%', height: '100%' }}
				title="Admin Login"
			/>
		</div>
	);
};